<template>
   <div v-if="cards" class="grid-wrapper" :class="[`layout-${layout}`]">
      <!-- Cards -->
      <header v-if="headline">
         <div class="text">
            <h4 class="bold">{{ headline }}</h4>
            <p class="small" v-if="description">{{ description }}</p>
         </div>
         <div class="slider-actions">
            <slot name="actions"></slot>
            <nuxt-link v-if="link" :to="link" class="grey">View All</nuxt-link>
         </div>
      </header>

      <slot name="filter"></slot>
      <!-- can now use the slot for complex issues -->
      <slot name="cardsWrapper">
         <div class="grid">
            <slot v-bind="cards">
               <component
                  v-for="(c, index) in cards"
                  :class="[`layout-${layout}`]"
                  :is="
                     card == 'smallCard' && c.type == 'notecard'
                        ? componentMap['noteCard']
                        : componentMap[card]
                  "
                  :card="c"
                  :key="c?.id || index"
               />
            </slot>
         </div>
      </slot>
      <div class="end-actions">
         <slot name="end-action"></slot>
      </div>
   </div>

   <!-- Loading State -->
   <div class="loading" v-else>Loading</div>
</template>
<script setup lang="ts">
const componentMap = {
   smallCard: resolveComponent("SmallCard"),
   imageCard: resolveComponent("ImageCard"),
   largeCard: resolveComponent("LargeCard"),
   mediaCard: resolveComponent("MediaCard"),
   classCard: resolveComponent("ClassCard"),
   noteCard: resolveComponent("NoteCard"),
};
const props = defineProps({
   headline: { type: String, default: null },
   description: { type: String, default: null },
   link: { type: [String, Object], default: null },
   cards: { type: Array, default: () => [] },
   card: {
      type: String,
      validator(value, props) {
         return [
            "smallCard",
            "imageCard",
            "largeCard",
            "mediaCard",
            "classCard",
         ].includes(value);
      },
   },
   layout: {
      type: String,
      default: "grid",
      validator: (value) => ["grid", "list", "media"].includes(value),
   },
});
const cards = toRef(props, "cards");
</script>

<style lang="scss">
@import "~/assets/scss/globals/card-grid";
</style>
